// extracted by mini-css-extract-plugin
export default {"heading":"alert-heading_heading__+zOal","clickable":"alert-heading_clickable__wIOjQ"};